import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _Map from "@babel/runtime-corejs3/core-js-stable/map";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import * as React from 'react';
import { useRef, useLayoutEffect } from 'react';
import classNames from 'classnames';
import { scrollTo, waitElementReady } from '../../utils';
import Context from '../../context';
function TimeUnitColumn(props) {
  var prefixCls = props.prefixCls,
    units = props.units,
    onSelect = props.onSelect,
    value = props.value,
    hideDisabledOptions = props.hideDisabledOptions,
    selectValue = props.selectValue;
  var cellPrefixCls = "".concat(prefixCls, "-cell");
  var _React$useContext = React.useContext(Context),
    open = _React$useContext.open;
  var ulRef = useRef(null);
  var liRefs = useRef(new _Map());
  var scrollRef = useRef();
  useLayoutEffect(function () {
    var li = liRefs.current.get(value);
    if (li && open !== false) {
      scrollTo(ulRef.current, li.offsetTop, 120);
    }
  }, [value, selectValue]);
  useLayoutEffect(function () {
    if (open) {
      var li = liRefs.current.get(value);
      if (li) {
        scrollRef.current = waitElementReady(li, function () {
          scrollTo(ulRef.current, li.offsetTop, 0);
        });
      }
    }
    return function () {
      var _a;
      (_a = scrollRef.current) === null || _a === void 0 ? void 0 : _a.call(scrollRef);
    };
  }, [open]);
  return /*#__PURE__*/React.createElement("ul", {
    className: classNames("".concat(prefixCls, "-column"), {
      // [`${prefixCls}-column-active`]: active,
    }),
    ref: ulRef,
    style: {
      position: 'relative'
    }
  }, _mapInstanceProperty(units).call(units, function (unit) {
    var _classNames;
    if (hideDisabledOptions && unit.disabled) {
      return null;
    }
    return /*#__PURE__*/React.createElement("div", {
      key: unit.value,
      ref: function ref(element) {
        liRefs.current.set(unit.value, element);
      },
      className: classNames(cellPrefixCls, (_classNames = {}, _defineProperty(_classNames, "".concat(cellPrefixCls, "-disabled"), unit.disabled), _defineProperty(_classNames, "".concat(cellPrefixCls, "-selected"), value === unit.value), _classNames)),
      onClick: function onClick() {
        if (unit.disabled) {
          return;
        }
        onSelect(unit.value);
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "".concat(cellPrefixCls, "-inner")
    }, unit.label));
  }));
}
export default TimeUnitColumn;